import firebaseApp from './firebaseApp'

export const fireDb = firebaseApp.database()

export const fireRef = fireDb.ref()
